const cacheKeys = {
  all: ['memberships'],
  list: () => [...cacheKeys.all, 'list'],
  byId: (id?: number | 'me') => [...cacheKeys.list(), { id }]
}

export default {
  endpoints: {
    memberships: '/memberships',
    membershipId: (id?: number | 'me') => `/memberships/${id}`,
    manageInterests: '/memberships/me/interests',
    changePassword: '/memberships/me/password'
  },
  cacheKeys
}
